import Image from './Fields/Image';

interface FormatItem {
    format: string;
}

interface StrValueItem {
    value: string;
}

interface NumValueItem {
    value: number;
}

export interface TIDItem {
    tid: number;
}

export interface FieldManufacturer {
    manufacturer: {
        tid: number;
        vid: number;
        name: string;
        description: string;
        format: string;
        weight: number;
    };
}

export type CategoryMapping = TIDItem & { description: string; };

export const GetInstrumentsOptionKeys: string[] = [
    'lefty',
    'as_is',
    'memorabilia',
    'featured',
    'category',
    'model',
    'year',
    'manufacturer',
    'price',
    'orderBy',
    'results_per_page',
    'page',
    'search',
    'vintage'
];

export interface GetInstrumentsOptions {
    lefty: boolean;
    as_is: boolean;
    memorabilia: boolean;
    featured: boolean;
    category: string;
    model: string;
    year: string;
    manufacturer: string;
    price: string;
    orderBy: string;
    results_per_page: number;
    page: number;
    vintage: boolean;
    [key: string]: boolean | string | number;
    // pricePoints: {low: number, high: number}[]; // -1 === inifinity, only relevant for over 10,000
}

export interface InventoryResponseData {
    current_page: number;
    last_page: number;
    data: InventoryInstrument[];
    first_page_url: string;
    prev_page_url: string;
    next_page_url: string;
    last_page_url: string;
    from: number;
    to: number;
    per_page: number;
    total: number;
}

export interface InventoryInstrument {
    nid: number;
    vid: number;
    type: string;
    language: string;
    title: string;
    uid: number;
    status: number;
    created: number;    // Numberic date
    changed: number;    // Numberic date
    comment: number;
    promote: number;
    sticky: number;
    tnid: number;
    translate: number;
    alias: string;
    instrument: any;
    instrument_refs: any;
    url: any;
    file: any;
    field_image: any;
    field_instr_as_is: StrValueItem;
    field_instr_asking_price: StrValueItem;
    field_instr_category: TIDItem;
    field_gruhn_category_id: (FormatItem & StrValueItem);
    field_instr_lefty: StrValueItem;
    field_instr_image_first: Image;
    field_instr_model: FormatItem & StrValueItem;
    field_manufacturer: TIDItem & FieldManufacturer;
    field_instr_product_description: FormatItem & StrValueItem & { summary: string };
    field_instr_year: FormatItem & StrValueItem;
}

export interface DetailInstrument {
    nid: number;
    vid: number;
    type: string;
    language: string;
    title: string;
    uid: number;
    status: number;
    created: number;    // Numberic date
    changed: number;    // Numberic date
    comment: number;
    promote: number;
    sticky: number;
    tnid: number;
    translate: number;
    meta_title: string;
    meta_description: string;
    alias: string;
    product_type: string;
    state: string;
    field_shopify: NumValueItem;
    field_shopifyid: StrValueItem;
    field_shopifyid_variant: StrValueItem;
    field_archive_instrument: NumValueItem;
    field_check_date: StrValueItem;
    field_check_number: StrValueItem;
    field_comments: StrValueItem;
    field_export_to_pos: StrValueItem;
    field_featured_group: NumValueItem;
    field_george_collection: NumValueItem;
    field_gruhn_category_id: (FormatItem & StrValueItem);
    field_homepage: NumValueItem;
    field_instr_asking_price: StrValueItem;
    field_instr_assets: StrValueItem;
    field_instr_as_is: StrValueItem;
    field_instr_buyer: StrValueItem;
    field_instr_category: TIDItem;
    field_instr_cogs: StrValueItem;
    field_instr_commision: StrValueItem;
    field_instr_consignment: StrValueItem;
    field_instr_consignment_rate: StrValueItem;
    field_instr_cons_repair_tax: StrValueItem;
    field_instr_cost: StrValueItem;
    field_instr_date_aquired: StrValueItem;
    field_instr_date_sold: StrValueItem;
    field_instr_do_not_list: StrValueItem;
    field_instr_full_repair_cost: StrValueItem;
    field_instr_hold_price: StrValueItem;
    field_instr_image: Image[];
    field_instr_income: StrValueItem;
    field_instr_invoice_num: StrValueItem;
    field_instr_invoice_number: (FormatItem & StrValueItem);
    field_instr_lefty: StrValueItem;
    field_instr_listid: FormatItem & StrValueItem;
    field_instr_map: StrValueItem;
    field_instr_map_cbox: NumValueItem;
    field_instr_model: FormatItem & StrValueItem;
    field_instr_mslp: StrValueItem;
    field_instr_mslp_cbox: StrValueItem;
    field_instr_product_description: FormatItem & StrValueItem & { summary: string };
    field_instr_purchaser: { uid: number };
    field_instr_repair_cost: StrValueItem;
    field_instr_sales_tax: StrValueItem;
    field_instr_seller: { target_id: number };
    field_instr_sold_price: StrValueItem;
    field_instr_taxable: StrValueItem;
    field_instr_total_cost: StrValueItem;
    field_instr_tracking_num: StrValueItem;
    field_instr_year: FormatItem & StrValueItem;
    field_manufacturer: TIDItem & FieldManufacturer;
    field_memorabilia: NumValueItem;
    field_method: TIDItem;
    field_repair_complete_data: StrValueItem;
    field_repair_data_repaired_by: StrValueItem;
    field_seller: StrValueItem;
    field_serial_number: FormatItem & StrValueItem;
    field_technical_info: StrValueItem;
    field_trade_in_invoice_date: StrValueItem;
    field_trade_in_invoice_number: StrValueItem;
}



// WEBPACK FOOTER //
// ./src/types/drupal/InstrumentNode.ts